import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_UGC_LINK_AUTOLINKING_ENABLED = defineFcm('ugc_link_autolinking_enabled')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				petitionDescription: { type: 'boolean' },
				movementDescription: { type: 'boolean' },
				petitionUpdate: { type: 'boolean' },
				comment: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		petitionDescription: false,
		movementDescription: false,
		petitionUpdate: false,
		comment: false,
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'UGC link processing',
		description:
			'Per-UGC-type kill switch for autolinking bare URLs into <a> tags in user-generated content. No key for DM responses — those autolink unconditionally today via linkify-string, unaffected by this config.',
		template: {
			petitionDescription: false,
			movementDescription: false,
			petitionUpdate: false,
			comment: false,
		},
	});
